import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class LeadsWhatsappMessagingHistoryService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.LEADS_MESSAGE_HISTORY = '/api/leads-message-history';

        this.GET_LIST_FILTERED = '/list/filtered';
        this.SEND_API_MESSAGE = '/send/message';
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS_MESSAGE_HISTORY + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async sendWhatsappApiMsg(bodyStr) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS_MESSAGE_HISTORY + this.SEND_API_MESSAGE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default LeadsWhatsappMessagingHistoryService;
